// Created by jarongallo at 3/31/21
import React, { useEffect, useState } from 'react';
import './styles';
import UIListInputRow from '../../../../../components/UI/UIListInputRow';
import { UI_LABELED_INPUT_BUTTON_TYPE } from '../../../../../components/UI/UILabeledInput/config';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { GET_AGENT_ADMIN } from './queries';
import Queries from '../../../../../utils/API/Queries';
import { toast } from 'react-toastify';
import * as strings from './strings';
import { allowInvoicing } from '../../IndividualTechnician/IndividualTechnicianAdmin/strings';
import { camelCaseToSentence } from '../../../../../utils/Helpers/StringHelpers';
import { UI_ICON_BUTTON_CANCEL_TYPE, UI_ICON_BUTTON_FILL_TYPE } from '../../../../../components/UI/UIIconButton/config';

export default function IndividualAgentAdmin({ agentId }: IndividualAgentAdminProps) {
	const [agent, setAgent] = useState<UserType>();

	const [updateAgentApi] = useMutation(Queries.UPDATE_USER_MUTATION, {
		onError: (error) => toast.error(strings.errorUpdatingUser(error.message))
	});

	const [getAgent, { data: agentData }] = useLazyQuery(GET_AGENT_ADMIN, {
		variables: { id: agentId }
	});

	useEffect(() => {
		(async () => {
			await getAgent();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (agentData) {
				const fetchedAgent: UserType = agentData['user'];
				setAgent(fetchedAgent);
			}
		})();
	}, [agentData]);

	if (!agent) return null;

	const updateAgent = async (key: string, value: any) => {
		await updateAgentApi({ variables: { id: agentId, [key]: value } });
		toast.success(strings.updateUserSuccess(camelCaseToSentence(key)));
	};

	return (
		<div className='individualAgentAdmin'>
			<UIListInputRow
				dark
				label={strings.allowInvoicingLabel}
				type={UI_LABELED_INPUT_BUTTON_TYPE}
				buttonType={agent.allowInvoicing ? UI_ICON_BUTTON_CANCEL_TYPE : UI_ICON_BUTTON_FILL_TYPE}
				value={agent.allowInvoicing ? strings.disableInvoicing : strings.allowInvoicing}
				onClick={() => updateAgent('allowInvoicing', !agent.allowInvoicing)}
			/>
		</div>
	);
}
